import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import { GlobalContext } from "../context/GlobalContext";
import { Table } from "flowbite-react";

const Detail = () => {
  const [data, setData] = useState(null);
  const { jobId } = useParams();
  const { setSelectedJob } = useContext(GlobalContext);

  useEffect(() => {
    if (jobId) {
      axios
        .get(`https://dev-example.sanbercloud.com/api/job-vacancy/${jobId}`)
        .then((res) => {
          setData(res.data);
          setSelectedJob(res.data);
        })
        .catch((error) => {
          console.log("Error fetching job detail:", error);
        });
    }
  }, [jobId, setSelectedJob]);

  if (!data) {
    return <div>Loading</div>;
  }

  return (
    <>
      <div className="m-4 lg:mb-6 lg:mx-8">
        <h3 className="text-2xl lg:text-4xl leading-6 font-medium text-gray-900">
          Job Information
        </h3>
      </div>
      <div className="bg-white shadow-xl border-2 mx-4 lg:mx-8 lg:p-8 overflow-hidden sm:rounded-lg">
        <div className="px-4 py-5 flex flex-col sm:flex-row sm:justify-between sm:items-center">
          <img
            src={data.company_image_url}
            className="w-24 sm:w-32 h-auto mb-4 sm:mb-0"
            alt="Company Logo"
          />
          <div className="flex flex-col justify-center">
            <h3 className="text-xl lg:text-4xl leading-6 font-medium text-gray-900">
              {data.company_name}
            </h3>
            <p className="mt-1 max-w-xs lg:max-w-2xl text-base lg:text-xl text-gray-500">
              {data.title}
            </p>
          </div>
        </div>
        <div className="overflow-x-auto">
          <Table striped>
            <Table.Body className="divide-y">
              <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                  Job Status
                </Table.Cell>
                <Table.Cell
                  style={{ fontWeight: "bold", color: data.job_status === 1 ? "green" : "red" }}
                >
                  {data.job_status === 1 ? "Open Hiring" : "Closed Hiring"}
                </Table.Cell>
              </Table.Row>
              <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                  Job Description
                </Table.Cell>
                <Table.Cell>{data.job_description}</Table.Cell>
              </Table.Row>
              <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                  Job Qualification
                </Table.Cell>
                <Table.Cell>{data.job_qualification}</Table.Cell>
              </Table.Row>
              <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                  Job Location
                </Table.Cell>
                <Table.Cell>{data.company_city}</Table.Cell>
              </Table.Row>
              <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                  Job Tenure
                </Table.Cell>
                <Table.Cell>{data.job_tenure}</Table.Cell>
              </Table.Row>
              <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                  Job Type
                </Table.Cell>
                <Table.Cell>{data.job_type}</Table.Cell>
              </Table.Row>
              <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                <Table.Cell className="whitespace-nowrap font-medium text-gray-900 dark:text-white">
                  Salary Range
                </Table.Cell>
                <Table.Cell>
                  Rp {data.salary_min} - Rp {data.salary_max}
                </Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </div>
      </div>
      <div className="flex justify-center mt-8">
        <Link
          to="/"
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
        >
          Apply
        </Link>
      </div>
    </>
  );
};

export default Detail;
